import React, { Component, ReactElement } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

function PrivateRoute(props: RouteProps): React.ReactElement | null {
  const user = localStorage.getItem("token");
  let isAuthenticated = false;

  if (user != null) {
    isAuthenticated = true;
  } else {
    localStorage.removeItem("username");
  }
  //alert(isAuthenticated);
  if(!isAuthenticated){
    let search = window.location.search.toLowerCase();
    let params = new URLSearchParams(search);
    let lastQueryType = params.get('qtype');
    if(lastQueryType!=null){
      localStorage.setItem("lastQueryType", lastQueryType);
      // alert('false2');
      //alert(lastQueryType);
  
    }

  }

  const { component: Component, ...restProps } = props;
  if (!Component) return null;

  return (
    <Route
      {...restProps}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
}

export default PrivateRoute;
